<template>
    <div>
        <v-simple-table dense>
            <thead>
                <tr>
                    <th>Rank</th>
                    <th>Customer</th>
                    <th>Net Sales</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(d, i) in data" :key="i">
                    <td class="d-flex align-center">
                        <v-icon color="yellow" class="me-1">mdi-star</v-icon>
                        <span class="font-weight-bold orange--text">{{i + 1}}</span>
                    </td>
                    <td>{{d.customer}}</td>
                    <td>{{formatNumber(d.total_sales)}}</td>
                </tr>
            </tbody>
        </v-simple-table>
    </div>
</template>

<script>
import chartAPI from './../../services/sales/chart';
import { formatNumber } from 'accounting';

export default {
    data() {
        return {
            data: [],
            
        }
    },
    computed: {
        
    },
    watch: {
        
    },
    methods: {
        formatNumber(n) {
            return formatNumber(n);
        },
        async fetch() {
            let res = await chartAPI.topCustomersOverall();
            this.data = res.data;
        }
    },
    mounted() {
        this.fetch();
    },
}
</script>

<style>

</style>

